import { render, staticRenderFns } from "./overlay.vue?vue&type=template&id=3c61f268&"
import script from "./overlay.vue?vue&type=script&lang=ts&"
export * from "./overlay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports